
    const coloSymptomsList=[
        {symptom:"rectalBleeding", 
        displayAs: "Rectal Bleeding",
        questionGroup:"rectalBleeding"
        },
      
        {symptom:"cobh",
        displayAs: "Change in Bowel Habit",
        questionGroup:"cobh"
        },
    
        
        {symptom:"rectalMass",
        displayAs: "Rectal or Anal Mass / Ulcer",
        questionGroup:"rectalMass"
        },
      
    ];
  

export default coloSymptomsList;